import { Component, OnInit, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertComponent } from '../../../common/alert/alert.component';
import { ContentComponent } from '../../../components/content/content.component';
import { BreadcrumbsComponent } from '../../../common/breadcrumbs/breadcrumbs.component';
import { FilterDataPipe } from '../../../pipes/filter-data.pipe';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LabelComponent } from '../../../common/label/label.component';
import { selectApplicationList, selectLoading, selectPending } from '../../../store/selectors/application.selectors';
import { Store } from '@ngrx/store';
import { loadApplicationList } from '../../../store/actions/application.actions';
import { SpinnerComponent } from '../../../common/spinner/spinner.component';
import { ApplicationListItem } from '../../../services/application.common.model';

@Component({
  selector: 'app-approved-list-page',
  standalone: true,
  imports: [
    CommonModule,
    AlertComponent,
    ContentComponent,
    BreadcrumbsComponent,
    FilterDataPipe,
    FormsModule,
    RouterModule,
    LabelComponent,
    SpinnerComponent
  ],
  templateUrl: './approved-list-page.component.html'
})
export class ApprovedListPageComponent implements OnInit {

  public filterValue: string = '';

  public applications: Signal<ApplicationListItem[]> = this.store$.selectSignal(selectApplicationList);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  constructor(private store$: Store) {
  }

  public ngOnInit(): void {
    this.store$.dispatch(loadApplicationList({ code: 'zatwierdzony' }));
  }
}
